module.exports = __webpack_public_path__ + "img/Woman-5.32770a5e.svg";